import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useColors } from "@inbody/core";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
function ManualSelectDialog({
  open,
  onClose,
  manuals
}) {
  const { t } = useTranslation("ui");
  const { gray, brand } = useColors();
  const handleSelect = (url) => {
    window.open(url, "_blank");
    onClose();
  };
  return /* @__PURE__ */ jsxs(
    Dialog,
    {
      open,
      onClose,
      fullWidth: true,
      maxWidth: "mobileWide",
      slotProps: {
        paper: {
          sx: {
            borderRadius: 4,
            border: `1px solid ${gray[100]}`,
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "hidden"
          }
        }
      },
      children: [
        /* @__PURE__ */ jsxs(
          DialogTitle,
          {
            sx: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              fontSize: "16px",
              fontWeight: 700,
              color: gray[900]
            },
            children: [
              t("매뉴얼 선택"),
              /* @__PURE__ */ jsx(
                IconButton,
                {
                  size: "small",
                  onClick: onClose,
                  "aria-label": "close",
                  sx: { color: gray[500] },
                  children: /* @__PURE__ */ jsx(CloseIcon, { sx: { fontSize: 18 } })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(Divider, { sx: { borderColor: gray[100] } }),
        /* @__PURE__ */ jsx(DialogContent, { sx: { p: 1 }, children: /* @__PURE__ */ jsx(Stack, { spacing: 0.5, children: manuals.map((m, idx) => /* @__PURE__ */ jsx(
          ButtonBase,
          {
            onClick: () => handleSelect(m.url),
            sx: {
              width: "100%",
              justifyContent: "flex-start",
              textAlign: "left",
              px: 1.5,
              py: 1.25,
              borderRadius: 2,
              color: gray[700],
              transition: "background-color 120ms, color 120ms",
              "&:hover": {
                backgroundColor: gray[50],
                color: brand[500]
              }
            },
            children: /* @__PURE__ */ jsxs(
              Stack,
              {
                direction: "row",
                alignItems: "center",
                spacing: 1.5,
                sx: { width: "100%" },
                children: [
                  /* @__PURE__ */ jsx(
                    Box,
                    {
                      sx: {
                        width: 36,
                        height: 36,
                        borderRadius: 1.5,
                        backgroundColor: brand[25],
                        color: brand[500],
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0
                      },
                      children: /* @__PURE__ */ jsx(PictureAsPdfOutlinedIcon, { sx: { fontSize: 20 } })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "body2",
                      sx: {
                        flex: 1,
                        fontWeight: 500,
                        color: "inherit",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      },
                      children: m.label
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    ChevronRightIcon,
                    {
                      sx: { fontSize: 18, color: gray[300], flexShrink: 0 }
                    }
                  )
                ]
              }
            )
          },
          idx
        )) }) })
      ]
    }
  );
}
export {
  ManualSelectDialog
};
